export const STATUS_LABELS = {
    contacted: "Contacted",
    contractPending: "Contract Pending",
    contractComplete: "Contract Complete",
};
export const PAGE_SIZE = 7;
